import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Action to fetch attendance summary data
export const fetchAttendanceSummary = createAsyncThunk("fetchAttendanceSummary", async ({ filters }) => {
	const formatDate = (date) => (date && date.isValid && date.isValid() ? date.format("YYYY-MM-DD") : "");

	// Clean filters - only include non-empty values
	const cleanFilters = {};

	// Add search keyword if it exists and is not undefined/empty
	if (filters?.keyword && typeof filters.keyword === "string" && filters.keyword.trim() !== "") {
		cleanFilters.search = filters.keyword.trim();
	}

	// Add date range if it exists
	if (filters?.dateRange && filters.dateRange[0] && filters.dateRange[1]) {
		cleanFilters.startDate = formatDate(filters.dateRange[0]);
		cleanFilters.endDate = formatDate(filters.dateRange[1]);
	}

	// Add company ID if it exists and is not empty string or undefined/null
	if (filters?.company && String(filters.company).trim() !== "" && filters.company !== undefined && filters.company !== null) {
		cleanFilters.companyId = filters.company;
	}

	// Add department ID if it exists and is not empty string or undefined/null
	if (filters?.department && String(filters.department).trim() !== "" && filters.department !== undefined && filters.department !== null) {
		cleanFilters.departmentId = filters.department;
	}

	// Add value chain ID if it exists and is not empty string or undefined/null
	if (filters?.valueChain && String(filters.valueChain).trim() !== "" && filters.valueChain !== undefined && filters.valueChain !== null) {
		cleanFilters.valueChainId = filters.valueChain;
	}

	// Add pagination and sorting parameters
	cleanFilters.page = filters?.page ?? 1;
	cleanFilters.limit = filters?.limit ?? 10;
	cleanFilters.sortBy = filters?.sortBy ?? "name";
	cleanFilters.sortOrder = filters?.sortOrder ?? "asc";

	const params = new URLSearchParams(cleanFilters);

	try {
		const response = await axiosHttp.get(`attendance/summary?${params}`);
		return response.data;
	} catch (error) {
		throw error;
	}
});

// Create attendance summary slice
const AttendanceSummarySlice = createSlice({
	name: "AttendanceSummarySlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	reducers: {},

	extraReducers: (builder) => {
		builder.addCase(fetchAttendanceSummary.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});

		builder.addCase(fetchAttendanceSummary.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload.data;
			state.pagination = {
				current: action.payload.current_page || 1,
				pageSize: action.payload.per_page || 10,
				total: action.payload.total || 0,
			};
		});

		builder.addCase(fetchAttendanceSummary.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || "Failed to fetch attendance data";
		});
	},
});

export const { clearAttendanceData, updatePagination } = AttendanceSummarySlice.actions;
export default AttendanceSummarySlice.reducer;
